<template>
  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
    <div class="dropbox">
      <input
        type="file"
        multiple
        :name="uploadFieldName"
        :disabled="isSaving"
        @change="
          filesChange($event.target.name, $event.target.files)
          fileCount = $event.target.files.length
        "
        class="input-file"
      />
      <p v-if="isInitial">Click here to browse or drag your file(s) here to begin</p>
      <p v-if="isSaving">
        {{ fileCount > 1 ? `Uploading ${fileCount} files...` : 'Uploading file...' }}
      </p>
    </div>
  </form>
</template>
<script>
import eventBus from '@/helpers/event-bus'
import {upload} from '../services/file-upload.js'
import {mapGetters} from 'vuex'

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3

export default {
  name: 'FileUpload',
  props: {
    url: {type: String, required: true},
    validate: {type: Boolean, default: false},
  },
  data() {
    return {
      fileCount: 0,
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'files',
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    },
    cleanUrl() {
      if (!this.url) return
      const params = `clientId=${this.clientId}&validate=${this.validate}`
      const paramOperator = this.url.includes('?') ? '&' : '?'

      return this.url + paramOperator + params
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING

      upload(this.cleanUrl, formData)
        .then(x => {
          this.uploadedFiles = [].concat(x)
          this.currentStatus = STATUS_SUCCESS
          this.$emit('success', x)
        })
        .catch(err => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
          this.$emit('error', err)
        })
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      const files = [...Array(fileList.length).keys()]
      files.map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name)
      })

      // save it
      this.save(formData)
    },
  },
  mounted() {
    this.reset()
    let vm = this
    eventBus.$on('doReset', () => {
      vm.currentStatus = STATUS_INITIAL
      vm.uploadedFiles = []
      vm.uploadError = null
      vm.fileCount = 0
    })
  },
}
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
